// extracted by mini-css-extract-plugin
module.exports = {"root":"tendance-catalogue-component_root__2hEDa","trendBloc":"tendance-catalogue-component_trendBloc__252rf"};